import { Typography, Box, TextField } from "@mui/material";
import "./QueryTermCard.css";

export const QueryTermCard = ({ setQuery, query }) => {
  return (
    <Box className="QueryTerm">
      <Typography variant="h6" component="h3" className="QueryTerm__Title">
        Query Term
      </Typography>
      <TextField
        variant="outlined"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        required
        multiline
        fullWidth
        className="QueryTerm__Input"
      />
    </Box>
  );
};
